import { registerPlugin } from '@capacitor/core';
const Keyboard = registerPlugin('Keyboard');
export * from './definitions';
export { Keyboard };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@capacitor/keyboard/dist/esm/index.js
// module id = 105
// module chunks = 112